import { render, staticRenderFns } from "./AnnouncementDeleteModal.vue?vue&type=template&id=0652570b&scoped=true&"
import script from "./AnnouncementDeleteModal.vue?vue&type=script&lang=js&"
export * from "./AnnouncementDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0652570b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0652570b')) {
      api.createRecord('0652570b', component.options)
    } else {
      api.reload('0652570b', component.options)
    }
    module.hot.accept("./AnnouncementDeleteModal.vue?vue&type=template&id=0652570b&scoped=true&", function () {
      api.rerender('0652570b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/LiveStream/Announcements/Includes/AnnouncementDeleteModal.vue"
export default component.exports